<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
			`accordion-${node.key}`
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div
			class="node-accordion"
			>
			<!-- :style="getMainStyle(node)"> -->
			<div
				v-for="(item, index) in node.options.items"
				:key="index"
				class="">
				<accordion
					:showArrow="true"
					:autoClose="autoClose"
					:arrowPosition="getIconPosition(node)"
					:icon="getIconClass(node.options, 'deactive')"
					:iconActive="getIconClass(node.options, 'active')"
					:iconSpacing="node.options.iconSpacing"
					:headerStyle="getHeaderStyle(node)"
					:headerActiveStyle="getHeaderActiveStyle(node)"
					:contentStyle="geContentStyle(node)"
					:openFirst="openFirst[index]">
					<template slot="heading">
						<div class="d-flex">
							<div>
								{{ item.title }}
							</div>
						</div>
					</template>
					<template slot="body">
						<NodeEditor
							:key="`${node.key}-${index}`"
							v-model="item.content"
							@focus="onNodeClick(node)"
						/>
					</template>
				</accordion>
			</div>

		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Accordion from '@/components/funnels/pagebuilder/parts/Accordion.vue';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	// eslint-disable-next-line
	getIconStyle,
	getRgbaColor,
	getNodeStyle,
	getIcon,
// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeAccordion',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
		Accordion,
	},
	data() {
		return {
			openFirst: {
				0: false,
				1: false,
			},
		};
	},
	computed: {
		autoClose() {
			const type = this?.node?.options?.type ?? 'toggle';
			const autoClose = type === 'collapse';
			return autoClose;
		},
	},
	mounted() {
		this.setAccordionOpenFirstValue();
		this.$nextTick(() => {
			this.listenCustomEvent();
		});
	},
	methods: {
		...mapActions({
			setActionElement: 'funnels/setActionElement',
		}),

		setAccordionOpenFirstValue() {
			const accordionItems = this.node.options.items;
			for (let i = 0; i < accordionItems.length; i++) {
				this.openFirst[i] = false;
			}
		},

		getMainStyle({ options }) {
			const style = {};
			let contentAlign = 'flex-start';
			style.display = 'flex';

			if (options) {
				const { align } = options;
				if (align === 'center') {
					contentAlign = 'center';
				} else if (align === 'right') {
					contentAlign = 'flex-end';
				}
			}
			style['justify-content'] = contentAlign;
			return style;
		},

		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getHeaderStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'title-color',
				// 'title-active-color',
				'title-font-size',
				'title-line-height',
				'title-bg-color',
				'title-border',
				'title-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getHeaderActiveStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'title-active-color',
				'title-font-size',
				'title-line-height',
				'title-bg-color',
				'title-border',
				'title-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		geContentStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'content-color',
				'content-font-size',
				'content-bg-color',
				'content-border',
				'content-padding',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},

		getItemStyle({ options }) {
			const style = {};

			if (options) {
				const { spaceBetween } = options;
				style['padding-bottom'] = `calc(${spaceBetween}px/2)`;
			}
			return style;
		},

		getIconStyle({ options }) {
			const style = {};

			if (options) {
				const device = this.previewDevice;

				style.color = options.iconColor && options.iconColor.rgb && options.iconColor.rgb !== ''
					? getRgbaColor(options.iconColor.rgb)
					: options.iconColor;

				if (device === 'desktop') {
					const fixedIconSizeUnit = options.iconSizeUnit && options.iconSizeUnit !== '' ? options.iconSizeUnit : 'px';
					style['font-size'] = options.iconSize && options.iconSize !== ''
						? `${options.iconSize}${fixedIconSizeUnit}`
						: '16px';
				} else if (device === 'mobile') {
					const fixedMobileIconSizeUnit = options.mobileIconSizeUnit && options.mobileIconSizeUnit !== '' ? options.mobileIconSizeUnit : 'px';
					style['font-size'] = options.mobileIconSize && options.mobileIconSize !== ''
						? `${options.mobileIconSize}${fixedMobileIconSizeUnit}`
						: '16px';
				}
			}
			return style;
		},

		getIconClass(item, type) {
			let icon = getIcon(item.iconKey, item.iconStyle);
			if (type === 'active') {
				icon = getIcon(item.iconKeyActive, item.iconStyleActive);
			}
			return icon;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
			// this.setActionElement({ type, node });
		},
		getIconPosition({ options }) {
			const position = options && options.iconPosition === 'after'
				? 'right'
				: 'left';
			return position;
		},
		listenCustomEvent() {
			window.addEventListener('accordionEvent', (event) => {
				const detail = event.detail;
				const key = detail.key;
				const index = detail.index;
				const value = detail.value;
				if (this.node.key === key) {
					this.openFirst[index] = value;
				}
			});
		},

	},
};
</script>

<style lang="scss">
</style>
